module.exports = __webpack_public_path__ + "img/menu_icon.0d006b16.png";